import Carousel from "react-bootstrap/Carousel";
import CardMedia from "@mui/material/CardMedia";

function CarouselFadeExample() {
  return (
    <Carousel fade>
      {/* 1  */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_1.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>입구</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 2  */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_2.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>송파사랑상품권 가맹점</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 3 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_2_1.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>서울아산병원 감사패</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 4 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_3.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>Information</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 5 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_4.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>대기실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 6 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_5.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>복도</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 7 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_6.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>복도</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 8 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_8.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 9 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_8_1.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 12 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_10.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>놀이치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 13 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_11.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>놀이치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 15 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_13.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>놀이치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 16 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_14_1.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 19 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_15.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>로고</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 20 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/송파_16.jpg" alt="송파" />
        <Carousel.Caption>
          <h3>Since 2013</h3>
          <p>성원언어상담연구소 송파점</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselFadeExample;
